// src/services/bulkStock.js

const API_URL = process.env.REACT_APP_API_URL;
const API_KEY = process.env.REACT_APP_API_KEY;

/**
 * Bulk update multiple stock items (mark as sold/unsold)
 * Single API call for all updates
 * 
 * @param {Array} updates - Array of { id, sold } objects
 * @returns {Promise} API response
 */
export const bulkUpdateStock = async (updates) => {
    try {
        const response = await fetch(API_URL, {
            method: "POST",
            body: JSON.stringify({
                action: "bulkUpdateStock",
                apiKey: API_KEY,
                origin: window.location.origin,
                updates: updates
            })
        });

        const jsonResponse = await response.json();
        console.log('Bulk Update Stock Response:', jsonResponse);
        return jsonResponse;

    } catch (error) {
        console.error('Bulk update stock error:', error);
        return {
            success: false,
            error: error.message
        };
    }
};

/**
 * Bulk delete multiple stock items
 * Single API call for all deletions
 * 
 * @param {Array} itemIds - Array of stock item IDs to delete
 * @returns {Promise} API response
 */
export const bulkDeleteStock = async (itemIds) => {
    try {
        const response = await fetch(API_URL, {
            method: "POST",
            body: JSON.stringify({
                action: "bulkDeleteStock",
                apiKey: API_KEY,
                origin: window.location.origin,
                itemIds: itemIds
            })
        });

        const jsonResponse = await response.json();
        console.log('Bulk Delete Stock Response:', jsonResponse);
        return jsonResponse;

    } catch (error) {
        console.error('Bulk delete stock error:', error);
        return {
            success: false,
            error: error.message
        };
    }
};

/**
 * Bulk mark items as sold
 * 
 * @param {Array} items - Array of stock items
 * @returns {Promise} API response
 */
export const bulkMarkAsSold = async (items) => {
    const updates = items.map(item => ({
        id: item.id,
        sold: "Yes"
    }));

    return bulkUpdateStock(updates);
};

/**
 * Bulk mark items as unsold
 * 
 * @param {Array} items - Array of stock items
 * @returns {Promise} API response
 */
export const bulkMarkAsUnsold = async (items) => {
    const updates = items.map(item => ({
        id: item.id,
        sold: "No"
    }));

    return bulkUpdateStock(updates);
};